import React from 'react';
import { Star } from 'lucide-react';

const reviews = [
  { author: 'Алексей М.', rating: 5, text: 'Купил ключ для PS5, активировался моментально. Цена ниже, чем в официальном магазине. Буду заказывать снова.' },
  { author: 'Дарья К.', rating: 5, text: 'Заказала подписку PS Plus, всё пришло сразу после оплаты. Поддержка ответила за 10 минут когда возник вопрос.' },
  { author: 'Игорь Р.', rating: 5, text: 'Отличный магазин. Уже третья покупка, проблем никогда не было. Рекомендую.' },
  { author: 'Юлия Т.', rating: 4, text: 'Всё хорошо, ключ рабочий. Немного долго ждала подтверждения, но в итоге всё получила.' },
  { author: 'Максим В.', rating: 5, text: 'Лучший магазин цифровых игр. Большой выбор, быстрая выдача, честные цены.' },
  { author: 'Анна С.', rating: 5, text: 'Купила несколько игр для Xbox, всё работает отлично. Спасибо за быструю доставку!' },
];

const Stars = ({ count }: { count: number }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`h-3.5 w-3.5 ${i < count ? 'fill-amber-400 text-amber-400' : 'text-foreground/15'}`}
      />
    ))}
  </div>
);

const ReviewsPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">Отзывы</h1>
        <p className="mt-3 text-foreground/40">Что говорят наши покупатели</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {reviews.map((r, i) => (
          <div
            key={i}
            className="rounded-[24px] border border-foreground/10 bg-card p-5"
          >
            <div className="mb-3 flex items-center justify-between">
              <span className="font-medium text-foreground">{r.author}</span>
              <Stars count={r.rating} />
            </div>
            <p className="text-sm leading-6 text-foreground/55">{r.text}</p>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default ReviewsPage;
